import React from 'react';

import { TextButton } from '@flipster/react/design-system';
import ChevronRightIcon from '@flipster/react/icon/generated/ChevronRightIcon';
import { css } from '@flipster/styled-system/css';
import { circle, hstack, stack } from '@flipster/styled-system/patterns';

export const HowToRedeem = () => {
  return (
    <div className={css({ mb: 12 })}>
      <div>
        <details
          className={css({
            color: 'content.default.level-4',
            borderBottom: '1px solid {colors.border.default.level-1}',
          })}
        >
          <summary
            className={css({
              py: 12,
              display: 'flex',
              justifyContent: 'space-between',
              textStyle: 'Text/M/Strong',
            })}
          >
            <p>How to redeem a share of the launchpool with your Sparks</p>
            <ChevronRightIcon
              size={20}
              className={css({
                transform: 'rotate(90deg)',
                transition: 'transform 0.2s',
                '[open] &': { transform: 'rotate(-90deg)' },
              })}
            />
          </summary>
          <ul className={stack({ mt: 4, mb: 12, gap: 16, textStyle: 'Text/M/Regular' })}>
            <ListItem n={1}>
              Rack up <TextButton as='a' label='Sparks' href='/spark/reward' css={{ verticalAlign: 'middle' }} /> by
              trading and depositing
            </ListItem>
            <ListItem n={2}>Join the Launchpool and input the amount of Sparks you want to spend</ListItem>
            <ListItem n={3}>
              The larger the amount of Sparks you use, the larger the share of the Launchpool you get
            </ListItem>
          </ul>
        </details>
      </div>
      <p className={css({ mt: 12, color: 'content.state.warning', textStyle: 'Text/M/Regular' })}>
        * Sparks used will not be returned
      </p>
    </div>
  );
};

interface ListItemProps extends React.PropsWithChildren {
  n: number;
}
const ListItem = ({ n, children }: ListItemProps) => {
  return (
    <li className={hstack({ gap: 10 })}>
      <span
        className={circle({
          width: 24,
          height: 24,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          textStyle: 'Text/S/Strong',
          bg: 'background.default.level-2',
        })}
      >
        {n}
      </span>
      <span>{children}</span>
    </li>
  );
};
